import { Component, Input, OnInit, ViewChild, ChangeDetectorRef, OnChanges, SimpleChanges, Renderer2 } from '@angular/core';
import { SignupComponent } from '../signup/signup.component';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { AlertMessageService } from 'src/app/modules/shared/_services/alert-message.service';
import { AuthService } from '../../_services/auth.service';

import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { VisitorService } from '../../_services/visitor.service';
import { Router } from '@angular/router';

interface DataLayerEvent {
  event: string;
  [key: string]: any;
}
declare const dataLayer: DataLayerEvent[];
@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})

export class VerifyOtpComponent implements OnInit, OnChanges {
  @Input() mobileNumber: any
  @Input() requestId: any
  @Input() isInterested: any;
  @Input() tenderdetails: any;
  @Input() whatsappConsent: any;

  isOtpValid = false;
  otp = '';
  countdown: number = 60; // Initialize countdown to 60 seconds
  countdownInterval: any; // Store interval ID

  @Input() openVerifyOTP: boolean = false;

  @ViewChild(SignupComponent) openSignUpModal!: SignupComponent;


  constructor(
    private authService: AuthService,
    private alertService: AlertMessageService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2, private visitorService: VisitorService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.openVerifyOTP) {
      this.startCountdown();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tenderdetails']) {
      this.cdr.detectChanges(); // Trigger change detection
    }
  }

  startCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval); // Clear any existing interval
    }
    this.countdown = 60; // Reset countdown to 60 seconds
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownInterval);
        this.enableResendButton();
      }
      this.cdr.detectChanges(); // Ensure view is updated
    }, 1000);
    this.disableResendButton(); // Disable the resend button initially
  }


  enableResendButton() {
    const button = document.querySelector('.blue-button') as HTMLButtonElement;
    if (button) {
      button.removeAttribute('disabled');
    }
  }

  disableResendButton() {
    const button = document.querySelector('.blue-button') as HTMLButtonElement;
    if (button) {
      button.setAttribute('disabled', 'true');
    }
  }

  errorMessage: any;
  resendOtp(): void {
    this.otpIncorrect = false;
    this.startCountdown();
    this.sharedService.otpSend(this.mobileNumber).subscribe(
      (res: any) => {
      },
      (error: any) => {
        this.otpIncorrect = true;
        this.errorMessage = "OTP limit reached. Please try again in 15 minutes.";
      }
    );
  }


  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  otpIncorrect = false;
  otpRes: any;

  async openBusinessInfoModal(otp: string): Promise<void> {
    const visitorId = await this.visitorService.getVisitorId();
    const json = {
      otpCode: otp,
      phone: this.mobileNumber,
      requestId: this.requestId,
      whatsappConsent: this.whatsappConsent,
      guestUserId: visitorId
    };
    this.sharedService.otpVerify(json).pipe(catchError((error) => {
      this.handleError(error);
      return of(null);
    })).subscribe((res: any) => {
      this.otpRes = res;
      if (res?.code === 200) {
        if (res?.data?.userId && res?.data?.email && res?.data?.isPreferencesSet) {
          const isLoggedIn = this.authService.login(res?.data?.userId, res?.data);
          if (isLoggedIn) {
            this.pushNormalUser();
            this.alertService.addSuccess('Successfully logged In').show();
            if (this.tenderdetails) {
              this.ThankyouMessagePopup(res?.data.leadId);
            } else {
              this.clearBlockingData();
              this.closeModal();
              this.router.navigate([this.router.url]);
            }
          }
        } else {
          this.openSignUpModal.mobileNumber = this.mobileNumber;
          this.openSignUpModal.openSignup = true;
          this.openSignUpModal.whatsappConsent = this.whatsappConsent;
          this.renderer.addClass(document.body, 'no-scroll');
          this.openSignUpModal.autoPopulateData(res?.data);
          this.openVerifyOTP = false;
        }
      } else {
        this.otpIncorrect = true;
        this.alertService.addError('OTP is incorrect. Please try again.').show();
      }
    });
  }

  private handleError(error: any): void {
    console.error("Error during OTP verification:", error);
    this.alertService.addError('An error occurred while verifying the OTP. Please try again later.').show();
    this.otpIncorrect = true;
  }

  private clearBlockingData(): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('Count');
      localStorage.removeItem('isB');
      localStorage.removeItem('StartTime');
    }
  }

  ThankyouMessagePopup(leadId: any): void {
    const requestData = {
      leadId: leadId,
      summary: this.tenderdetails?.summary,
      tenderRefId: this.tenderdetails?.tenderRefId,
      workDescription: this.tenderdetails?.workDescription
    };
    this.sharedService.subscribeTenders(requestData).subscribe(res => {
      this.closeModal();
    });
  }

  pushNormalUser(): void {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push({
        'event': 'sign_up/login'
      });
    } else {
      console.warn("dataLayer is not defined.");
    }
  }

  onOtpInputChange(digitNumber: number, event: any): void {
    if (this.sharedService.isBrowser) {
      const digitValue = event.target.value;

      if (digitValue) {
        const nextDigitNumber = digitNumber + 1;
        const nextDigitInput = <HTMLInputElement>document.getElementById(`digit-${nextDigitNumber}`);
        if (nextDigitInput) {
          nextDigitInput.focus();
        }
      }

      const digit1 = (<HTMLInputElement>document.getElementById('digit-1'))?.value || '';
      const digit2 = (<HTMLInputElement>document.getElementById('digit-2'))?.value || '';
      const digit3 = (<HTMLInputElement>document.getElementById('digit-3'))?.value || '';
      const digit4 = (<HTMLInputElement>document.getElementById('digit-4'))?.value || '';
      const digit5 = (<HTMLInputElement>document.getElementById('digit-5'))?.value || '';
      const digit6 = (<HTMLInputElement>document.getElementById('digit-6'))?.value || '';

      this.otp = digit1 + digit2 + digit3 + digit4 + digit5 + digit6;
      this.isOtpValid = !!(digit1 && digit2 && digit3 && digit4 && digit5 && digit6);
    }
  }

  onOtpKeyDown(digitNumber: number, event: any) {
    if (this.sharedService.isBrowser) {
      const digitValue = event.target.value;
      const previousDigitNumber = digitNumber - 1;

      if (event.key === 'Backspace') {
        if (!digitValue && digitNumber > 1) {
          const previousDigitInput = <HTMLInputElement>document.getElementById(`digit-${previousDigitNumber}`);
          if (previousDigitInput) {
            previousDigitInput.value = '';
            previousDigitInput.focus();
          }
        }
      }
    }
  }

  closeModal() {
    this.openVerifyOTP = false;
  }

}
